import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationWrapper } from 'utils/common-methods';
import appleStoreLogo from '../../assets/images/apple-store-logo.svg';
import googlePlayLogo from '../../assets/images/google-play-logo.svg';
import protectorMobileLogo from '../../assets/images/protector-mobile-logo.svg';
import protectorScoutingLogo from '../../assets/images/protector-scouting-logo.svg';
import protectorPhone from '../../assets/images/protector_mkt_phone.png';
import './styles.less';

const ProtectorAppsStores: React.FC = () => {
  const SCOUTING_APPLE_STORE: string = 'https://apps.apple.com/gb/app/protector-scouting/id1534604384';
  const SCOUTING_PLAY_STORE: string = 'https://play.google.com/store/apps/details?id=ag.strider.scout.uk';
  const MOBILE_APPLE_STORE: string = 'https://apps.apple.com/gb/app/syngenta-digital-protector/id1528399874';
  const MOBILE_PLAY_STORE: string = 'https://play.google.com/store/apps/details?id=ag.strider.protector.uk';

  const onClickOpenStore = (url: string) => {
    window.open(url);
  };
  const { t } = translationWrapper(useTranslation(), false);
  return (
      <div className="protector-apps-container">
          <div className="protector-apps-container__right">
              <img alt="" src={protectorPhone}/>
          </div>
          <div className="protector-apps-container__left">
              <div className="protector-apps-text-container">
                    <span>
                        {t('Our mobile apps are')}
                    </span>
                  <span>
                        {t('made for the field')}
                    </span>
              </div>
              <span className="protector-apps-subtext">{t('Available on AppStore and Google Play.')}</span>
              <div className="protector-apps-icon-container">
                  <div className="protector-apps-icon-container__row">
                      <img alt="" className="protector-apps-icon-container__logo" src={protectorMobileLogo}/>
                      <span>{t('Protector Mobile')}</span>
                      <div className="store-container">
                          <img alt="" className="store-container__logo" src={googlePlayLogo} onClick={() => { onClickOpenStore(MOBILE_PLAY_STORE); }} />
                          <img alt="" className="store-container__logo" src={appleStoreLogo} onClick={() => { onClickOpenStore(MOBILE_APPLE_STORE); }} />
                      </div>
                  </div>
                  <div className="protector-apps-icon-container__row">
                      <img alt="" className="protector-apps-icon-container__logo" src={protectorScoutingLogo}/>
                      <span>{t('Protector Scouting')}</span>
                      <div className="store-container">
                          <img alt="" className="store-container__logo" src={googlePlayLogo} onClick={() => { onClickOpenStore(SCOUTING_PLAY_STORE); }} />
                          <img alt="" className="store-container__logo" src={appleStoreLogo} onClick={() => { onClickOpenStore(SCOUTING_APPLE_STORE); }} />
                      </div>
                  </div>
              </div>
          </div>
      </div>
  );
};

export default ProtectorAppsStores;
